import React from "react";

var styles = {
  attachmentVideo: {
    maxHeight: "inherit",
    maxWidth: "inherit",
    minHeight: "inherit",
    minWidth: "inherit",
    objectFit: "cover",
    color: "white",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
  },
  overlay: {
    maxHeight: "inherit",
    maxWidth: "inherit",
    minHeight: "inherit",
    minWidth: "inherit",
    opacity: "0.6",
    background: "",
    position: "absolute",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    top: "0",
    left: "0",
    width: "100%",
    height: "100%",
    cursor: "pointer",
  },
};

export default ({
  attachmentSrc,
  preview = false,
  icon,
  backgroundColor = "black",
  fontSize = "65px",
  outlined = false,
}) => {
  const classes = styles;
  const getSourceType = (src) => {
    if (!src) return "video/mp4";
    
    if (src.includes('.webm')) {
      return "video/webm";
    } else if (src.includes('.mp4')) {
      return "video/mp4";
    } else if (src.includes('.mov')) {
      return "video/quicktime";
    } else if (src.includes('.ogg')) {
      return "video/ogg";
    } else {
      return "video/mp4";
    }
  };
  
  return preview ? (
    <div style={{ ...classes.attachmentVideo, background: backgroundColor }}>
      <video style={classes.attachmentVideo} preload="auto">
        <source src={`${attachmentSrc}#t=1`} type={getSourceType(attachmentSrc)}></source>
        {!attachmentSrc.includes('.webm') && <source src={`${attachmentSrc}#t=1`} type="video/webm"></source>}
        {!attachmentSrc.includes('.mp4') && <source src={`${attachmentSrc}#t=1`} type="video/mp4"></source>}
      </video>
      <div style={{ position: "absolute" }}>{icon}</div>
    </div>
  ) : (
    <div style={classes.attachmentVideo}>
      <video
        src={attachmentSrc}
        style={classes.attachmentVideo}
        preload="metadata"
        type={getSourceType(attachmentSrc)}
      />
      <div style={{ ...classes.overlay, background: backgroundColor }}>
        <span
          className="material-icons"
          style={{
            fontSize,
          }}
        >
          {outlined ? "play_circle_outline" : "play_circle_filled"}
        </span>
      </div>
    </div>
  );
};
